export default __webpack_public_path__ + "./assets/userresearch-still.jpg";